const formInputField = 'form-input'
const termsCheckBox = 'terms-checkbox'
const firstNameField = 'form-first-name-input'
const lastNameField = 'form-last-name-input'

export { formInputField, termsCheckBox, firstNameField, lastNameField }